import _ from 'lodash'
import moment from 'moment/moment'
import { arrayToSentence } from '@utils/string-helpers'

export const technologyIcons = {
  MottoLearn: {
    coreTechnology: true,
    tailoredTechnology: false,
    desktopImg: require('@assets/tech-icons/desktop/MottoCenter-D-TOOLS-Learn.png'),
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/55/mottolearn-introduction-catalog',
    alt: 'MottoLearn',
    description: 'Education platform with access to courses, webinars, and live sessions.',
  },
  MottoSwag: {
    coreTechnology: true,
    tailoredTechnology: false,
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/62/mottoswag-introduction-catalog',
    desktopImg: require('@assets/tech-icons/desktop/MottoCenter-D-TOOLS-Swag.png'),
    alt: 'MottoSwag',
    description: 'Motto branded online store.',
  },
  MottoMail: {
    coreTechnology: true,
    tailoredTechnology: false,
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/61/mottomail-introduction-catalog',
    desktopImg: require('@assets/tech-icons/desktop/MottoCenter-D-TOOLS-Mail.png'),
    alt: 'MottoMail',
    description:
      'A branded email address to communicate with your borrowers and partners effectively and professionally. Add it to marketing materials to put the power of the brand to work for you.',
  },
  Mimecast: {
    coreTechnology: true,
    tailoredTechnology: false,
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/60/mimecast-introduction-catalog',
    desktopImg: require('@assets/tech-icons/desktop/MottoCenter-D-TOOLS-Mimecast.png'),
    alt: 'Mimecast',
    description:
      'A layer of security to Manage your on-hold queues in your Mimecast Personal Portal. Email messages can be released or rejected either individually or in bulk.',
  },
  Wemlo: {
    coreTechnology: false,
    tailoredTechnology: true,
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/54/wemlo-lbs-intorduction-catalog',
    desktopImg: require('@assets/tech-icons/desktop/2021-wemlo-TILES-D_FNL_3-01.png'),
    alt: 'wemlo LBS',
    description:
      'Originate your loans in our broker channel solution for streamlining the entire mortgage transaction workflow. Get connected directly with loan processors and get back to doing what you do best.',
    descriptionByGroups: {
      'Broker Owner':
        'you have access to the broker’s origination system, wemlo LBS℠, which includes a brokerage level account that you have access to, which allows you to add lender and vendor credentials for all users, set up QC business rules and ABAs in the system, and view/reconcile the office’s full pipeline.',
      'Operations Manager':
        'you have access to the broker’s origination system, wemlo LBS℠, which includes a brokerage level account that you have access to, which allows you to add lender and vendor credentials for all users, set up QC business rules and ABAs in the system, and view/reconcile the office’s full pipeline.',
      'Loan Originator Phase 2':
        'you can access wemlo℠ LBS (Loan Brokering System) which was designed to enable mortgage loan originators (MLOs) to close loans each month while providing the seamless digital mortgage experience expected by today’s homebuyers. Features include enhanced Automated Underwriting System (AUS) feedback, a borrower portal that allows borrowers to track the status of their loan in real-time, and in-platform communication that fosters on-time closings by keeping the broker, loan processor, title company, real estate agents, and borrowers all in close contact.',
      'LOA - Licensed':
        "you can access the office's leads and pipeline in wemlo℠ LBS, so you can assist with loan origination as desired by your team.",
      'LOA - Unlicensed':
        "you can access the office's leads and pipeline in wemlo℠ LBS, so you can assist with loan origination as desired by your team.",
      'In-house Processor':
        'you can access your loans and loans assigned to you in wemlo℠ LBS. You will be able to complete the loan processing tasks to assist the LO with closing the loan.',
    },
  },
  MottoSpark: {
    coreTechnology: false,
    tailoredTechnology: true,
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/56/mottospark-introduction-catalog',
    desktopImg: require('@assets/tech-icons/desktop/MottoCenter-D-TOOLS-Spark.png'),
    alt: 'MottoSpark',
    description:
      'Your Customer Management System (CRM) and Marketing Operating System (MOS), which is powered by Total Expert, and is integrated in real time with your LBS. MottoSpark is designed to empower you and your team by aligning sales, marketing, and compliance—all in one user-friendly platform.',
    descriptionByGroups: {
      'Broker Owner':
        'you can log in as the other users in your office to gain access to their contacts and loan information, curate and manage media assets on their behalf, and see an office-level view of their pipelines.',
      'Operations Manager':
        'you can log in as the other users in your office to gain access to their contacts and loan information, curate and manage media assets on their behalf, and see an office-level view of their pipelines.',
      'Loan Originator Phase 2':
        'you can log in to manage your contacts and pipeline, which are updated in real time by both Wemlo LBS and any leads submitted though your LO landing page on the office website. Manage email and print marketing, as well as create single property websites and lead capture apps, all while taking advantage of co-marketing opportunities with agents.',
      'Marketing Specialist':
        'you can log in as the other users in your office to gain access to their contacts and loan information, curate and manage media assets on their behalf, and see an office-level view of their pipelines.',
    },
  },
  MottoRep: {
    coreTechnology: false,
    tailoredTechnology: true,
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/57/mottorep-introduction-catalog',
    desktopImg: require('@assets/tech-icons/desktop/MottoCenter-D-TOOLS-Rep.png'),
    alt: 'MottoRep',
    description:
      'Your online reputation management platform, which helps to drive local engagement through review aggregation, listing management, social calendar posts, digital ads, and surveys.',
    descriptionByGroups: {
      'Broker Owner':
        'you can manage your office listing at the Office level as well as manage your team of Loan Originators at the Location level. You have the option to subscribe to a calendar developed by Motto HQ and send out scheduled posts.',
      'Operations Manager':
        'you can manage your office listing at the Office level as well as manage your team of Loan Originators at the Location level. You have the option to subscribe to a calendar developed by Motto HQ and send out scheduled posts.',
      'Loan Originator Phase 2':
        'you can manage your own location which enables you to link your social media and Google My Business accounts to aggregate reviews across the web in one place!  Monitor online conversations and engagmeent, address feedback, and plan your SEO strategy to promote your brand.',
      'Marketing Specialist':
        'you can manage your office listing at the Office level as well as manage your team of Loan Originators at the Location level. You have the option to subscribe to a calendar developed by Motto HQ and send out scheduled posts.',
    },
  },
  Website: {
    coreTechnology: false,
    tailoredTechnology: true,
    mottoLearnUrl: 'https://mottomortgage.docebosaas.com/pages/58/your-motto-website-introduction-catalog',
    desktopImg: require('@assets/tech-icons/desktop/MottoCenter-D-TOOLS-Website.png'),
    alt: 'Website',
    description: 'Access the back end of your published Motto Mortgage office website or LO landing page.',
    descriptionByGroups: {
      'Loan Originator Phase 2':
        'you can access the back end of your published MLO landing page on the office website.  You can manage new leads and add custom pages and content.',
      'Motto Mortgage Website Administrator':
        'you can access the back end of your published Office website.  Your dashboard will provide  access to multiple tools such as My Website Content, Marketing, and Lead Submissions. You also have access to add custom pages and content for the office website.',
    },
  },
  WemloSandbox: {
    coreTechnology: false,
    tailoredTechnology: true,
    mottoLearnUrl:
      'https://mottomortgage.docebosaas.com/pages/63/wemlo-lbs-sandbox-introduction-catalog-for-loan-originators',
    desktopImg: require('@assets/tech-icons/desktop/2021-wemlo-TILES-D_FNL_3-03.png'),
    alt: 'wemlo Sandbox',
    description:
      'Log into your loan origination test environment to create practice loan files and run multiple scenarios. Create test borrowers so you can better understand the borrower experience.',
    descriptionByGroups: {
      'Loan Originator Phase 1':
        "you can access your office's test environment which is an exact copy of the production environement.  MLOs can practice loan scenarios and workflows outside of their wemlo LBS production platform.",
      'Loan Originator Phase 2':
        "you can access your office's test environment which is an exact copy of the production environement.  MLOs can practice loan scenarios and workflows outside of their wemlo LBS production platform.",
    },
  },
}

export const getGroupDaysAgeByPersonnelLabel = (userGroups, personnelLabel, user) => {
  let groupLabel = personnelLabel
  if (personnelLabel === 'In-house Processor') {
    groupLabel = 'Loan Processor'
  }

  if (personnelLabel === 'Loan Originator Phase 1' || personnelLabel === 'Loan Originator Phase 2') {
    groupLabel = 'Loan Originator'
  }

  const group = _.find(userGroups, { label: groupLabel })
  let groupChangedAt = group?.createdAt || null

  if (personnelLabel === 'Loan Originator Phase 2') {
    groupChangedAt = user.loPhaseChangedAt
  }

  if (personnelLabel === 'Motto Mortgage Website Administrator') {
    groupChangedAt = _.first(_(user.webAdminChangedAts).orderBy(_.identity, 'asc').value())
  }

  if (!groupChangedAt) {
    return 99
  }

  return moment().diff(moment(groupChangedAt), 'days')
}

export const isNewGroupByPersonnelLabel = (personnelLabel, user) => {
  const daysLimit = 10
  return getGroupDaysAgeByPersonnelLabel(user?.groups, personnelLabel, user) <= daysLimit
}

export const getDescriptionsForNewTailoredTechApps = (
  appName,
  user,
  { onlyNewGroups = false, addNewAsterisk = true } = {}
) => {
  const app = technologyIcons[translateOktaAppNameToTechnologyIcon(appName)]

  if (!app || !app.tailoredTechnology) {
    return ''
  }

  let myUserGroups = user?.groupPersonnelLabels || []

  if (user?.isWebAdmin) {
    myUserGroups = [...myUserGroups, 'Motto Mortgage Website Administrator']
  }

  const groups = _.keys(app.descriptionByGroups)
  const groupedDescriptions = groups.reduce((prev, curr) => {
    if (!myUserGroups.includes(curr)) {
      return prev
    }

    const description = app.descriptionByGroups[curr]
    if (_.has(prev, description)) {
      prev[description] = prev[description] + ', ' + curr
      return prev
    }

    prev[description] = curr
    return prev
  }, {})

  const groupDescriptions = _.keys(groupedDescriptions)
    .filter((description) => {
      const groups = groupedDescriptions[description].split(',')
      const isNewGroup = groups.every((group) => isNewGroupByPersonnelLabel(group.trim(), user))
      if (onlyNewGroups) {
        return isNewGroup
      }

      return true
    })
    .map((description) => {
      const groups = groupedDescriptions[description].split(',')
      const isNewGroup = groups.every((group) => isNewGroupByPersonnelLabel(group.trim(), user))
      const correctArticle = groups[0].match(/^[OI|]|^LOA/) ? 'an' : 'a'
      const groupsHtml = groups.map((group) => {
        if (isNewGroup && addNewAsterisk) {
          return `${group}<span class="color-secondary-orange" style="margin-left: 3px;">*</span>`
        }
        return group
      })
      return {
        title: `As ${correctArticle} ${arrayToSentence(groupsHtml)}`,
        groups: arrayToSentence(groupsHtml),
        description: `${description}`,
        isNewGroup,
      }
    })

  if (!groupDescriptions.length) {
    return []
  }

  return [
    {
      originalAppTitle: appName,
      title: app.alt,
      description: `${app.description}`,
    },
    ...groupDescriptions,
  ]
}

export const isAppNewAccess = (appName, user, options) => {
  if (!user) {
    return false
  }

  const groupDescriptions = getDescriptionsForNewTailoredTechApps(appName, user, options) || []
  return groupDescriptions.some((groupDescription) => groupDescription.isNewGroup)
}

const translateOktaAppNameToTechnologyIcon = (appName) => {
  const translations = {
    'wemlo LBS': 'Wemlo',
    'wemlo LBS Sandbox': 'WemloSandbox',
    'Motto Website': 'Website',
  }

  return translations[appName] || appName
}
